export const HeadTitles = ["Hungry ?","Unexpected guests ?","Late night at office ?","Cooking gone wrong ?","Party Time ?"]
